import React from "react"

import * as clearview from "../../../../../components/@Clearview"

import { useState } from "react"
import { Button, FormGroup, InputGroup, InputGroupAddon, Modal, ModalHeader, ModalBody, ModalFooter } from "../../../../../components"
import { Schedule } from "./Schedule"
import { NominalCode } from "./NominalCode"

export function AddUpdateScheduleCode({ config, isOpen, onCancel, onSave, value = {} }) {
	config = {
		title: "Add",
		buttonLabel: "Update",
		...config,
	}

	const [row, setRow] = useState({ ...value })
	const [showErrors, setShowErrors] = useState(false)
	const onOpened = e => {
		setRow({ ...value })
		setShowErrors(false)
	}

	const updateRow = (name, value) => {
		setRow(prevState => ({ ...prevState, [name]: value }))
		setShowErrors({ isChanged: true })
	}

	const errors = () => {
		const myErrors = []
		if (!row.schedule) myErrors.push("Schedule is required.")
		if (!row.code) myErrors.push("Code is required.")
		return myErrors
	}

	const labelWidth = "5rem"
	return (
		<Modal isOpen={isOpen} style={{ maxWidth: 700 }} onOpened={onOpened}>
			<ModalHeader tag="h6">{config.title}</ModalHeader>

			<ModalBody>
				<FormGroup row>
					<InputGroup>
						<InputGroupAddon style={{ width: labelWidth }} addonType="prepend">
							Schedule
						</InputGroupAddon>
						<Schedule value={row.schedule} onChange={val => updateRow("schedule", val)} />
					</InputGroup>
				</FormGroup>

				<FormGroup row>
					<InputGroup style={{ width: "12rem" }}>
						<div className="input-group-prepend input-group-text" style={{ width: labelWidth }}>
							Code
						</div>
						<NominalCode
							value={row.code}
							onChange={val => {
								updateRow("code", val?.code)
								updateRow("nominalCode", val)
							}}
						/>
					</InputGroup>
					<div className="mt-2 ml-2">{row.nominalCode?.name}</div>
				</FormGroup>
			</ModalBody>

			<ModalFooter>
				{clearview.listErrors(errors(), !showErrors)}
				<Button color="link" onClick={onCancel}>
					Cancel
				</Button>
				<Button color="primary" name="update" onClick={e => (!errors().length && onSave(row)) || setShowErrors(true)}>
					{config.buttonLabel}
				</Button>
			</ModalFooter>
		</Modal>
	)
}
